import axiosInstance from "./index";

export const getResources = () => {
  return axiosInstance.get("resources");
};
